import { useEffect } from 'react';

import { useStoreContext } from 'features/store';
import { useAutoSelectStore } from 'features/store/hooks';
import { useIntl } from 'react-intl';

import { toaster } from 'components/toaster/toaster';
import useAuthFlow from 'state/auth/hooks/use-auth-flow';
import { useGeolocation } from 'state/geolocation';
import { LaunchDarklyFlag, useFlag } from 'state/launchdarkly';
import LocalStorage, { StorageKeys } from 'utils/local-storage';

export const AutoSelectStore = () => {
  // The useAutoSelectRestaurant hook is housed here so we can conditionally call it with an LD flag at parent level
  const { confirmRestaurant, restaurantToConfirm } = useAutoSelectStore();
  const { noStoreSelected } = useStoreContext();
  const { isPermissionGranted } = useGeolocation();
  const { formatMessage } = useIntl();
  const enableDeliveryOnly = useFlag(LaunchDarklyFlag.ENABLE_DELIVERY_ONLY);

  const { activeRouteIsSignIn, hasSignedOut } = useAuthFlow();
  const storeAddress = restaurantToConfirm?.physicalAddress?.address1;

  useEffect(() => {
    if (
      isPermissionGranted &&
      storeAddress &&
      noStoreSelected &&
      !activeRouteIsSignIn &&
      !hasSignedOut &&
      !enableDeliveryOnly // This prevent to auto-select a restaurant when the flag is turned on
    ) {
      toaster.informative(formatMessage({ id: 'closestStoreSelected' }));
      confirmRestaurant(true);
      LocalStorage.setItem(StorageKeys.SKIP_AUTO_SELECT_PROMPT, true);
    }
  }, [
    isPermissionGranted,
    confirmRestaurant,
    enableDeliveryOnly,
    formatMessage,
    hasSignedOut,
    activeRouteIsSignIn,
    noStoreSelected,
    storeAddress,
  ]);

  return null;
};
